import emissionsPageData from "../../../data/arabic/emissions-page-data-ar";
import MainHeader from "../../../layouts/MainHeader";
import EmissionsHeaderImage from '../../../assets/images/wallpaper/emissions.jpg';
import ReactVisibilitySensor from "react-visibility-sensor";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";
import PrimaryColoredSection from "../../../components/sections/ColoredSection/PrimaryColoredSection";
import BorderCenterLabel from "../../../components/Labels/BorderCenterLabel";
import Footer from "../../../layouts/Footer";
import Separator from "../../../components/Separator";
import TitleBorderLeft from "../../../components/Text/TitleBorderLeft";
import EmissionsPlan from '../../../assets/images/plans/plan-one-ar.svg';

const EmissionsPageAr = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view-two">
                <div className="sticky-container">
                    <MainHeader 
                        image={{
                            src : EmissionsHeaderImage,
                            alt : "Solar panals"
                        }}
                        title=""
                    />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    <div className="wrapper-small">
                        <h1 className={`title-center`}>{emissionsPageData.title}</h1>
                        <p className={`text-paragraph`}>{emissionsPageData.paraghraphOne}</p>
                        <p className={`text-paragraph`}>{emissionsPageData.paraghraphTwo}</p>
                        <div className="space-50"></div>
                        <Separator />
                        <div className="space-50"></div>
                        <TitleBorderLeft>{emissionsPageData.sectionOne.title}</TitleBorderLeft>
                        <div className="table-wrapper">
                        <table className="table-secondary">
                            <thead>
                                <tr></tr>
                                <tr>
                                    <th></th>
                                    <th className="">القياس</th>
                                    <th className="">2021</th>
                                    <th className="">2022</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>المساحة الكلية للمكتب الرئيسي لبنك الأول </td>
                                    <td className="">متر مربع</td>
                                    <td className="">114,613</td>
                                    <td className="">114,613*</td>
                                </tr>
                                <tr>
                                    <td>إجمالي استهلاك الكهرباء</td>
                                    <td className="">كيلوواط ساعة</td>
                                    <td className="">39,349,384</td>
                                    <td className="">34,941,966 <sup className="red-text a-mark">&#9398;</sup></td>
                                </tr>
                            </tbody>
                        </table>
                        </div>

                        <p className="text-note"><sup className="red-text a-mark">&#9398;</sup> خضع هذا المقياس للسنة المنتهية في 31 ديسمبر 2022 لتأكيد محدود ومستقل من جانب شركة برايس ووترهاوس كوبرز للمحاسبين القانونيين ("PwC")، وللحصول على تفاصيل إضافية، يُرجى الاطلاع على معايير إعداد التقارير لدينا وتقرير التأكيد المحدود لشركة بي دبليو سي عبر زيارة الموقع الإلكتروني (الرابط).</p>
                        <p className="text-note">* مساحة المباني الإجمالية المستخدمة لاحتساب استهلاك الكهرباء تستثني البيانات المتعلقة بالمباني غير التابعة للبنك والتي تشغل 99،135 متر مربع إضافية، علماً بأن هذه البيانات خارج نطاق التحليل.</p>
                            
                    </div>
                    
                    <div className="wrapper-small">
                        <BorderLeftBox 
                            title={emissionsPageData.sectionTwo.title}
                            subtitle={emissionsPageData.sectionTwo.subtitle}
                        />
                        <div className="emission-plan-wrapper">
                            <img 
                                src={EmissionsPlan} 
                                className="emission-plan" 
                                alt="a figure discripe the SAB scops"
                            />
                        </div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <p className={`text-paragraph`}>{emissionsPageData.sectionThree.description}</p>
                    </div>
                    {
                    emissionsPageData.sectionThree.labels.map((item, index) => (
                        <BorderCenterLabel
                            key={index}
                            boxes={item}
                        />
                    ))
                    }
                    <div className="space-50"></div>
                    <div className='wrapper-small'>
                        <p className="text-paragraph">{emissionsPageData.sectionThree.pargraph}</p>
                        <div className="space-50"></div>
                        <TitleBorderLeft>{emissionsPageData.sectionFour.title}</TitleBorderLeft>
                    </div>
                    {
                    emissionsPageData.sectionFour.labels.map((item, index) => (
                        <BorderCenterLabel 
                            key={index}
                            boxes={item}
                        />
                    ))
                    }
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="wrapper-small">
                        <BorderLeftBox 
                            title={emissionsPageData.sectionFive.boxOne.title}
                            subtitle={emissionsPageData.sectionFive.boxOne.subtitle}
                        />
                        <p className="text-paragraph">{emissionsPageData.sectionFive.paragraphOne}</p>
                        <p className="text-paragraph">{emissionsPageData.sectionFive.paragraphTwo}</p>
                        <TitleBorderLeft>{emissionsPageData.sectionFive.title}</TitleBorderLeft>
                    </div>
                        {
                        emissionsPageData.sectionFive.labels?.map((item,index) => (
                            <BorderCenterLabel 
                                key={index}
                                boxes={item}
                            />
                        ))
                        }
                        <div className='space-50'></div>
                    <div className="wrapper-small">
                        <p className="text-note">{emissionsPageData.sectionFive.note}</p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <PrimaryColoredSection 
                        bg={2}
                        customerImageClass="customer-image-class"
                        card={{
                            image : {
                                src : require(`../../../assets/images/cards/${emissionsPageData.sectionSix.card.image.name}`),
                                alt : emissionsPageData.sectionSix.card.image.alt,
                            }
                        }}
                        info={emissionsPageData.sectionSix.info}
                        title={emissionsPageData.sectionSix.title}
                        labels={emissionsPageData.sectionSix.labels}
                    />
                    <div className="wrapper-small">
                        <p className="text-note">{emissionsPageData.sectionSix.note}</p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <Footer withBlogs={false} />
                </div>
            </div>
            
        </main>
  )
}

export default EmissionsPageAr